module.exports = __webpack_public_path__ + "img/erweima.3731f039.png";